export function confirmationMixin() {
  
  const getPrettyDob = (birthDate) => {
    // we don't want to 'format' birthday with timezone...
    if (birthDate) {
      return `${birthDate.substr(5, 2)}/${birthDate.substr(8, 2)}/${birthDate.substr(0, 4)}`;
    }
    return '';
  };

  const getHiddenValue = (str) => {
    if (str === undefined || str.length === 0) {
      return '';
    }

    const last = str.substr(str.length - 2);
    const hidden = (() => {
      const first = str.substr(0, str.length - 2);
      let stars = '';
      for (let i = 0; i < first.length; i++) {
        if (first.substr(i, 1) !== '/') {
          stars = stars + '*';
        } else {
          stars = stars + '/';
        }
      }
      return stars;
    })();
    return `${hidden}${last}`;
  };

  return {
    getPrettyDob,
    getHiddenValue,
  };
}